/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Checkbox, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Chip, Box, Typography,
  useTheme, alpha
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LayoutBaseDeFinanceiro } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import dayjs from 'dayjs';
import { FerramentasDaListagemFinanceiro } from '../../../shared/components';
import { DialoDesconto } from './DialogDesconto';
import { DialoBaixa } from './DialogBaixa';
import { v4 as uuidv4 } from 'uuid';
import { ContasPagarService, IListagemContasPagar } from '../../../shared/services/api/Financeiro/ContasPagar';
import PDFPagar from './ImpressaoPagar';
import { BasicSelect } from '../../../shared/forms';

export const ListagemContasPagar: React.FC = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const navigate = useNavigate();
  const [rows, setRows] = useState<IListagemContasPagar[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [istexto, setIsTexto] = useState(false);
  const [isAutoComplete, setIsAutoComplete] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [selecionado, setSelecionado] = useState(0);
  const [open, setOpen] = useState(false);
  const [openBaixa, setOpenBaixa] = useState(false);
  const [nome, setNome] = useState('');
  const [data, setData] = useState(true);
  const [bstatus, setBstatus] = useState(true);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const hoje = dayjs();
  const primeiroDiaMes = dayjs().startOf('month');

  const [dataInicial, setDataInicial] = useState(primeiroDiaMes.format('YYYY-MM-DD'));
  const [dataFinal, setDataFinal] = useState(hoje.format('YYYY-MM-DD'));

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

  const guuid = uuidv4();

  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  const basicstatus = useMemo(() => {
    return searchParams.get('basicstatus') || 'false';
  }, [searchParams]);

  const parceiroselect = useMemo(() => {
    return searchParams.get('parceiroselect') || '';
  }, [searchParams]);

  const tipo = useMemo(() => {
    return searchParams.get('tipo') || 'parceiro';
  }, [searchParams]);

  const idparceiro = useMemo(() => {
    return searchParams.get('parceiro') || '';
  }, [searchParams]);

  useEffect(() => {
    const urlDataI = searchParams.get('datainicial') || dataInicial;
    const urlDataF = searchParams.get('datafinal') || dataFinal;
    setDataInicial(urlDataI);
    setDataFinal(urlDataF);
  }, [searchParams]);

  useEffect(() => {
    if (tipo === 'data') {
      setData(true);
      setIsTexto(false);
      setIsAutoComplete(false);
      setRows([]);
      const hoje = dayjs();
      const primeiroDiaMes = dayjs().startOf('month');

      setDataInicial(primeiroDiaMes.format('YYYY-MM-DD'));
      setDataFinal(hoje.format('YYYY-MM-DD'));

      setSearchParams({
        tipo: 'data',
        datainicial: primeiroDiaMes.format('YYYY-MM-DD'),
        datafinal: hoje.format('YYYY-MM-DD')
      }, { replace: true });

      setTotalCount(0);
      setBstatus(true);
    }
    else if (tipo === 'parceiro') {
      setIsAutoComplete(true);
      setIsTexto(false);
      setData(false);
      setRows([]);
      setSearchParams({ tipo: 'parceiro' }, { replace: true });
      setTotalCount(0);
      setBstatus(false);
    } else {
      setIsTexto(true);
      setIsAutoComplete(false);
      setData(false);
      setRows([]);
      setSearchParams({ tipo: 'r.numerodoc' }, { replace: true });
      setTotalCount(0);
      setBstatus(true);
    }
  }, [tipo]);

  useEffect(() => {
    if (tipo === 'r.numerodoc' && busca != '') {
      setIsLoading(true);
      debounce(() => {
        ContasPagarService.getAll(1, '', '', busca, 'numero')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setSelecionado(result.selecionado);
              setTotal(result.total);
              setRows(result.data);
            }
          });
      });
    }
    setIsLoading(false);
  }, [busca]);

  useEffect(() => {
    if (tipo === 'data' && dataInicial && dataFinal) {
      setIsLoading(true);
      debounce(() => {
        ContasPagarService.getAll(1, dataInicial, dataFinal, '', 'data')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setRows(result.data);
              setSelecionado(result.selecionado);
              setTotal(result.total);
            }
          });
      });
    } else {
      setRows([]);
    }
  }, [dataInicial, dataFinal]);

  useEffect(() => {
    if (tipo === 'parceiro' && idparceiro != '') {
      setIsLoading(true);
      setNome(parceiroselect);
      debounce(() => {
        ContasPagarService.getAll(1, '', '', idparceiro, 'parceiro')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setRows(result.data);
              setSelecionado(0);
              setTotal(result.total);
            }
          });
      });
    } else {
      setRows([]);
    }
  }, [idparceiro]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = rows.findIndex(row => row.idpagar === id);
    if (index === -1) return;

    const updatedRow = { ...rows[index], marcado: checked };
    const updatedRows = [...rows.slice(0, index), updatedRow, ...rows.slice(index + 1)];
    setRows(updatedRows);

    const valorNumerico = Number(updatedRow.vpagar);
    const valueToUpdate = checked ? valorNumerico : -valorNumerico;

    setSelecionado(currentSelecionado => currentSelecionado + valueToUpdate);
  };

  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const updatedRows = rows.map(row => {
      if (row.boleto) {
        return { ...row, marcado: checked };
      } else {
        return { ...row, marcado: false };
      }
    });
    setRows(updatedRows);

    if (checked) {
      const totalSelecionado = updatedRows
        .filter(row => row.boleto && row.marcado)
        .reduce((acc, row) => {
          const valorNumerico = Number(row.vpagar);
          return acc + valorNumerico;
        }, 0);
      setSelecionado(totalSelecionado);
    } else {
      setSelecionado(0);
    }
  };

  const handleClose = (newValue?: string) => {
    setOpen(false);
    if (newValue) {
      // setValue(newValue); 
    }
  };

  const handleCloseBaixa = (newValue?: string) => {
    setOpenBaixa(false);
    if (newValue === 'true') {
      ContasPagarService.getAll(1, '', '', idparceiro, 'parceiro')
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  };

  const handleDesconto = () => {
    if (totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpen(true);
    }
  };

  const handleBaixa = () => {
    if (totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpenBaixa(true);
    }
  };

  const handleSave = async () => {
    if (totalCount != 0) {
      setIsLoading(true);
      const marcados = rows.map(listItem => ({
        idpagar: listItem.idpagar,
        marcado: listItem.marcado,
        desconto: listItem.desconto,
        vpagar: listItem.vpagar,
      }));
      try {
        const result = await ContasPagarService.Marcados(marcados);
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        }
      } catch (error) {
        setIsLoading(false);
        setTms('error');
        setMsg('Ocorreu um erro ao processar.');
        setOpenmsg(true);
      }
    }
  };

  const handleDesc = (dados?: IListagemContasPagar[]) => {
    if (dados) {
      setRows(dados);
    }
  };

  const handletotal = (valor?: number) => {
    if (valor) {
      setSelecionado(valor);
    }
  };
  const isVencida = (vencimento: Date) => {
    return dayjs(vencimento).isBefore(dayjs(), 'day');
  };
  const formatarCpfCnpj = (cpfCnpj: string) => {
    const apenasNumeros = cpfCnpj.replace(/\D/g, '');
    if (apenasNumeros.length === 11) {
      return apenasNumeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (apenasNumeros.length === 14) {
      return apenasNumeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return cpfCnpj;
  };
  const handlePrint = () => {
    setIsLoading(true);
    if (selecionado != 0 && totalCount != 0) {
      const filteredList = rows.filter((item) => item.marcado === true);
      PDFPagar(filteredList, total, nome);
    } else {
      setTms('error');
      setMsg('Selecione uma Conta');
      setOpenmsg(true);
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  return (
    <LayoutBaseDeFinanceiro
      titulo='Contas a Pagar'
      labelSelecionado='Selecionado'
      labeltotal='Total a Pagar'
      total={total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      selecionado={selecionado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      barraDeFerramentas={
        <FerramentasDaListagemFinanceiro
          mostrarInputBusca={istexto}
          mostrarInputData={tipo === 'data'}
          mostrarAutoComplete={isAutoComplete}
          mostrarInputBasicSelect
          textSelectFalse='Pagar'
          textSelectTrue='Pagas'
          textoDaBusca={busca}
          dataInicial={dataInicial}
          dataFinal={dataFinal}
          textoDoSelect={tipo}
          textoDoStatus={basicstatus}
          disbilitarBaixar={bstatus}
          disbilitarDesconto={bstatus}
          disbilitarSalvar={bstatus}
          disbilitarImprimir={
            tipo !== 'parceiro' || basicstatus === 'true'
          }
          textoBotaoNovo='Adicionar'
          aoClicarEmNovo={() => navigate('/contaspagar/novo')}
          aoClicarEmDesconto={handleDesconto}
          aoClicarEmSalvar={handleSave}
          aoClicarEmImpressao={() => handlePrint()}
          aoClicarEmBaixa={handleBaixa}
          aoMudarDataInicial={dataInicial =>
            setSearchParams({
              tipo: tipo,
              datainicial: dataInicial,
              datafinal: dataFinal
            }, { replace: true })
          }
          aoMudarDataFinal={datafinal =>
            setSearchParams({
              tipo: tipo,
              datainicial: dataInicial,
              datafinal: datafinal
            }, { replace: true })
          }
          aoMudarTextoDeBusca={texto =>
            setSearchParams({
              busca: texto,
              tipo: tipo,
              datainicial: dataInicial,
              datafinal: dataFinal
            }, { replace: true })
          }
          aoMudarTextoDoSelect={textoselect =>
            setSearchParams({
              busca: busca,
              tipo: textoselect,
              datainicial: dataInicial,
              datafinal: dataFinal
            }, { replace: true })
          }
          aoMudarTextoDoParceiro={(texto, texto1) =>
            setSearchParams({
              parceiroselect: texto1,
              parceiro: texto,
              busca: busca,
              tipo: tipo,
              datainicial: dataInicial,
              datafinal: dataFinal
            }, { replace: true })
          }
        />
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          mx: 1,
          mb: 1,
          borderRadius: 2,
          overflow: 'auto',
          maxHeight: 'calc(100vh - 200px)',
          boxShadow: theme.shadows[1],
          '&:hover': {
            boxShadow: theme.shadows[2]
          },
          width: '98%'
        }}
      >
        <Table
          size="small"
          sx={{
            minWidth: 1200,
            tableLayout: 'auto',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.08) }}>
              <TableCell padding="checkbox" sx={{ width: '5%', px: 0.5 }}>
                <Checkbox
                  checked={rows.length > 0 && rows.every(row => row.marcado)}
                  onChange={handleSelectAllChange}
                  color="primary"
                  size="small"
                />
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: 'bold', width: '15%', px: 0.5 }}>Parceiro</TableCell>
              <TableCell align="left" sx={{ fontWeight: 'bold', width: '12%', px: 0.5 }}>CPF/CNPJ</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Emissão</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%', px: 0.5 }}>Vencimento</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', width: '6%', px: 0.5 }}>Parcela</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '10%', px: 0.5 }}>Número</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Valor</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>V.Parcela</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Juros/Acré.</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Pago</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '8%', px: 0.5 }}>Desc</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', width: '9%', px: 0.5 }}>V.Pagar</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', width: '7%', px: 0.5 }}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => {
              const vencida = isVencida(row.vencimento);
              const podeMarcar = row.boleto && !row.status;

              return (
                <TableRow
                  key={row.idpagar}
                  hover
                  sx={{
                    cursor: 'pointer',
                    backgroundColor: !podeMarcar ? alpha(theme.palette.warning.light, 0.05) :
                      row.marcado ? alpha(theme.palette.primary.light, 0.08) : 'inherit',
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.light, 0.12)
                    }
                  }}
                >
                  <TableCell padding="checkbox" sx={{ width: '5%', px: 0.5 }}>
                    {podeMarcar ? (
                      <Checkbox
                        checked={row.marcado}
                        id={row.idpagar}
                        onChange={handleChange}
                        color="primary"
                        size="small"
                      />
                    ) : null}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {row.nome}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {formatarCpfCnpj(row.cpf)}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {dayjs(row.emissao).format('DD/MM/YY')}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                      {dayjs(row.vencimento).format('DD/MM/YY')}
                      {vencida && (
                        <Chip
                          label="Vencida"
                          size="small"
                          color="error"
                          sx={{ mt: 0.3, height: '16px', fontSize: '0.55rem', minWidth: '45px' }}
                        />
                      )}
                      {!row.boleto && (
                        <Chip
                          label="Não Boleto"
                          size="small"
                          color="warning"
                          sx={{ mt: 0.3, height: '16px', fontSize: '0.55rem', minWidth: '55px' }}
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {row.parcela}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {row.numero}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      fontWeight: 'bold',
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {Number(row.vcompra).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: !row.boleto ? theme.palette.warning.dark :
                        vencida ? theme.palette.error.main : 'inherit'
                    }}
                  >
                    {Number(row.vparcela).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: theme.palette.warning.dark,
                    }}
                  >
                    {Number(row.acrescimo).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: theme.palette.success.main,
                    }}
                  >
                    {Number(row.vpago).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      color: theme.palette.info.main,
                    }}
                  >
                    {Number(row.desconto).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontSize: '0.75rem',
                      px: 0.5,
                      fontFamily: 'monospace',
                      fontWeight: 'bold',
                      color: vencida ? theme.palette.error.main :
                        !row.boleto ? theme.palette.warning.dark : 'inherit'
                    }}
                  >
                    {Number(row.vpagar).toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                  <TableCell align="center" sx={{ px: 0.5 }}>
                    <IconButton
                      size='small'
                      onClick={() => navigate(`/contaspagar/${row.idpagar}`)}
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                        padding: '3px',
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.primary.main, 0.15)
                        }
                      }}
                    >
                      <Icon sx={{ fontSize: '16px' }}>edit</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>

          {totalCount === 0 && !isLoading && (
            <TableRow>
              <TableCell colSpan={14} align="center" sx={{ py: 3 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Icon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }}>receipt</Icon>
                  <Typography variant="h6" color="text.secondary">
                    {Environment.LISTAGEM_VAZIA}
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={14}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

      <DialoDesconto
        open={open}
        onClose={handleClose}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      />

      <DialoBaixa
        value={guuid}
        open={openBaixa}
        onClose={handleCloseBaixa}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      />
    </LayoutBaseDeFinanceiro>
  );
};